import { Routes } from '@angular/router';
import { AuthGuardService } from './auth/services/auth-guard.service';
import { adminGuard } from './features/admin/admin.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/search',
        pathMatch: 'full'
    },
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth-routing.module').then(m => m.AuthRoutingModule)
    },
    {
        path: '',
        canActivate: [AuthGuardService],
        children: [
            {
                path: 'dashboard',
                loadComponent: () => import('./features/dashboard/dashboard').then(m => m.DashboardComponent),
                title: 'Dashboard - Ubiquity'
            },
            {
                path: 'search',
                loadComponent: () => import('./features/search/search').then(m => m.SearchPageComponent),
                title: 'Search - Ubiquity'
            },
            {
                path: 'search/:id',
                loadComponent: () => import('./features/search/search-results/search-results').then(m => m.SearchResultsComponent),
                title: 'Search Results - Ubiquity'
            },
            {
                path: 'search-results',
                loadComponent: () => import('./features/search/search-results/search-results').then(m => m.SearchResultsComponent),
                title: 'Search Results - Ubiquity'
            },
            {
                path: 'map',
                loadComponent: () => import('./features/map/map-page.component').then(m => m.MapPageComponent),
                title: 'Map Explorer - Ubiquity'
            },
            {
                path: 'datasets/:id',
                loadComponent: () => import('./features/datasets/dataset-detail.component').then(m => m.DatasetDetailComponent),
                title: 'Dataset - Ubiquity'
            },
            {
                path: 'jobs',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./features/jobs/jobs-list/jobs-list').then(m => m.JobsListComponent),
                        title: 'All Jobs - Ubiquity'
                    },
                    {
                        path: 'location/:locationId',
                        loadComponent: () => import('./features/jobs/jobs-location/jobs-location').then(m => m.JobsLocationComponent),
                        title: 'Location Jobs - Ubiquity'
                    },
                    {
                        path: ':id',
                        loadComponent: () => import('./features/jobs/job-details/job-details').then(m => m.JobDetailsComponent),
                        title: 'Job Details - Ubiquity'
                    }
                ]
            },
            {
                path: 'sources',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./features/sources/components/sources-list.component').then(m => m.SourcesListComponent),
                        title: 'Sources List - Ubiquity'
                    },
                    {
                        path: ':locationId',
                        loadComponent: () => import('./features/sources/components/sources-viewer.component').then(m => m.SourcesViewerComponent),
                        title: 'View Sources - Ubiquity'
                    }
                ]
            },
            {
                path: 'feeds',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./features/feeds/components/feed-list/feed-list.component').then(m => m.FeedListComponent),
                        title: 'Feeds - Ubiquity'
                    },
                    {
                        path: 'create',
                        loadComponent: () => import('./features/feeds/components/feed-create-wizard/feed-create-wizard.component').then(m => m.FeedCreateWizardComponent),
                        title: 'Create Feed - Ubiquity'
                    },
                    {
                        path: ':id',
                        loadComponent: () => import('./features/feeds/components/feed-details/feed-details.component').then(m => m.FeedDetailsComponent),
                        title: 'Feed Details - Ubiquity'
                    },
                    {
                        path: ':id/edit',
                        loadComponent: () => import('./features/feeds/components/feed-details/feed-details.component').then(m => m.FeedDetailsComponent),
                        title: 'Edit Feed - Ubiquity'
                    }
                ]
            },
            {
                path: 'pipelines',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./features/pipelines/components/pipeline-list/pipeline-list.component').then(m => m.PipelineListComponent),
                        title: 'Pipelines - Ubiquity'
                    },
                    {
                        path: ':id',
                        loadComponent: () => import('./features/pipelines/components/pipeline-details/pipeline-details.component').then(m => m.PipelineDetailsComponent),
                        title: 'Pipeline Details - Ubiquity'
                    }
                ]
            },
            {
                path: 'reports',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./features/reports/reports').then(m => m.Reports),
                        title: 'Reports - Ubiquity'
                    },
                    {
                        path: 'demo',
                        loadComponent: () => import('./features/reports/reports').then(m => m.Reports),
                        title: 'Demo Report - Ubiquity'
                    }
                ]
            },
            {
                path: 'monitoring',
                loadComponent: () => import('./features/monitoring/monitoring.component').then(m => m.MonitoringComponent),
                title: 'Cost Monitoring - Ubiquity'
            },
            {
                path: 'settings',
                loadComponent: () => import('./features/settings').then(m => m.SettingsComponent),
                title: 'Settings - Ubiquity'
            },
            {
                path: 'account',
                loadComponent: () => import('./features/account/account.component').then(m => m.AccountComponent),
                title: 'Account - Ubiquity'
            },
            {
                path: 'admin',
                canActivate: [adminGuard],
                loadChildren: () => import('./features/admin/admin.routes').then(m => m.ADMIN_ROUTES)
            }
        ]
    },
    {
        path: '**',
        redirectTo: '/search'
    }
];